import {
  Routes,
} from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth/login',
  },

  {
    path: 'auth',
    loadChildren: () =>
      import(
        './features/auth/auth.routes'
        ).then(
        module =>
          module.authRoutes,
      ),
  },

  {
    path: 'staff',
    loadChildren: () =>
      import(
        './features/staff/staff.routes'
        ).then(
        module =>
          module.staffRoutes,
      ),
  },

  {
    path: 'partner',
    loadChildren: () =>
      import(
        './features/partner/partner.routes'
        ).then(
        module =>
          module.partnerRoutes,
      ),
  },

  {
    path: '**',
    redirectTo: 'auth/login',
  },
];
